import cx from 'classnames'

import {BASE_CLASS, FORM_COMMENT_SPACING, HEADING_BASE_CLASS} from './config.js'

function getRootClassNames(baseClass, {shadow, showTitle, spacing}) {
  return cx(baseClass, {
    [`${baseClass}--noTitle`]: !showTitle,
    [`${baseClass}--spacingNone`]: spacing === FORM_COMMENT_SPACING.NONE,
    [`${baseClass}--spacingMedium`]: spacing === FORM_COMMENT_SPACING.MEDIUM,
    [`${baseClass}--shadow`]: shadow
  })
}

function getHeadingClassNames(baseClass, {showTitle}) {
  return cx(HEADING_BASE_CLASS, {
    [`${HEADING_BASE_CLASS}--noTitle`]: !showTitle
  })
}

export function getClassNames({shadow, showTitle, spacing}) {
  return {
    headingClassNames: getHeadingClassNames(HEADING_BASE_CLASS, {showTitle}),
    rootClassNames: getRootClassNames(BASE_CLASS, {shadow, showTitle, spacing})
  }
}
